import { inject } from "aurelia-dependency-injection";
import { AxiosInstance } from "axios";
import { IFindAllQuery, IReciboFlexible, IReciboFlexiblePago } from "./recibo-flexibles.interfaces ";
import { IBaseResponse } from "./base.response.interfaces";
import { IFilterDataFlex } from "./recibo.interfaces";

@inject('axios')
export class RecibosFlexiblesGateway {

    constructor(
        private axios: AxiosInstance
    ) {

    }

    public async findAll(query?: IFindAllQuery): Promise<IReciboFlexible[]> {
        try {
            const response = await this.axios.get('recibos-flexibles', {
                params: {
                    ...query,
                    expires: Date.now(),
                }
            });

            if (response.status !== 200 && response.status !== 403) {
                throw new Error('Bad response status: ' + response.statusText);
            }

            return response.data;
        } catch (e) {
            return [];
        }
    }

        public async getCount(query?: IFindAllQuery): Promise<number> {
            try {
                const response = await this.axios.get('recibos-flexibles/count', {
                    params: {
                        ...query,
                        expires: Date.now(),
                    }
                });
    
                if (response.status !== 200 && response.status !== 403) {
                    throw new Error('Bad response status: ' + response.statusText);
                }
    
                return response.data;
            } catch (e) {
                return 0;
            }
        }

        public async getListadoPagosFlexibles(idRecibo: number): Promise<IReciboFlexiblePago[]> {
                const response = await this.axios.get(`recibos-flexibles/pagos/${idRecibo}`);
        
                if (response.status !== 200 && response.status !== 403) {
                    throw new Error('Bad response status: ' + response.statusText);
                }
        
                return response.data;
            }
        
            public async generarModelos(recibos: number, importe: number): Promise<IBaseResponse<string>> {
                const response = await this.axios.post('recibos-flexibles/generar-modelo', {
                    idRecibo: recibos,
                    importe: importe
                });
        
                if (response.status !== 201 && response.status !== 403) {
                    throw new Error('Bad response status: ' + response.statusText);
                }
        
                return response.data;
            }
        
            public async getFilterData(query?: IFindAllQuery): Promise<IFilterDataFlex> {
                try {
                    const response = await this.axios.get('recibos-flexibles/filters', {
                        params: {
                            ...query,
                            expires: Date.now(),
                        }
                    });
        
                    if (response.status !== 200 && response.status !== 403) {
                        throw new Error('Bad response status: ' + response.statusText);
                    }
        
                    return {
                        organismos: response.data.organismos.map((x: any) => ({ value: x.codigo, label: x.nombre })),
                    };
                } catch (e) {
                    return {};
                }
            }

            public async print(referencia: string, tipoModelo: string, localizador: string): Promise<Blob> {
                try {
                    //console.log(`CALL -- autonomicos/print?tipoModelo=${tipoModelo}&localizador=${localizador}&referencia=${referencia}`)
                    const response = await this.axios.get(`autonomicos/print?tipoModelo=${tipoModelo}&localizador=${localizador}&referencia=${referencia}`, {
                        responseType: 'blob',
                    });
        
                    if (response.status !== 200 && response.status !== 403) {
                        throw new Error('Bad response status: ' + response.statusText);
                    }
        
                    return response.data;
                } catch (error) {
                    //console.log('error',error)
                    return {} as Blob
                }
            }
        
        
}